import { RootAction } from "../actions";
import { getPlanName } from "../lib/plan";
import { RootState } from "../types/state";
import { setGAUserProperties } from "../utils/analytics";
import { initialState } from "../utils/initialState";

export const reducer: React.Reducer<RootState, RootAction> = (
  state: RootState,
  action: RootAction
) => {
  console.log("🔨action", action.type);
  switch (action.type) {
    case "setUserInfo":
      if (action.payload.user) {
        // Set GA4 user properties with campaign data
        // This includes all standard properties PLUS campaign attribution
        setGAUserProperties({
          user_id: action.payload.user?.uid,
          sex: action.payload.user?.sex,
          age: action.payload.user?.age?.toString(),
          location: action.payload.user?.location,
          subscription: "isPaidSubscriber" in action.payload.user 
            ? getPlanName(action.payload.user) 
            : undefined
        });
      }

      if (!action.payload.isLoggedIn && !action.payload.user?.uid) {
        return {
          ...initialState,
          authResolved: state.authResolved
        };
      }

      return {
        ...state,
        user: action.payload.user,
        member: action.payload.member ?? state.member,
        isLoggedIn: action.payload.isLoggedIn,
        authResolved: state.authResolved
      };
    case "user":
      return {
        ...state,
        user: action.payload.user
      };
    case "searchParams":
      return {
        ...state,
        searchParams: action.payload.searchParams
      };
    case "displayUsers":
      return {
        ...state,
        displayUsers: action.payload.displayUsers
      };
    case "displayUsersForSearch":
      return {
        ...state,
        displayUsersForSearch: action.payload.displayUsersForSearch
      };
    case "searchedUsersByAge":
      return {
        ...state,
        searchedUsersByAge: action.payload.searchedUsersByAge
      };
    case "searchedUsersByLocation":
      return {
        ...state,
        searchedUsersByLocation: action.payload.searchedUsersByLocation
      };
    case "searchedUsersByAvailableDate":
      return {
        ...state,
        searchedUsersByAvailableDate:
          action.payload.searchedUsersByAvailableDate
      };
    case "searchedUsersByHeight":
      return {
        ...state,
        searchedUsersByHeight: action.payload.searchedUsersByHeight
      };
    case "searchedUsersByMarried":
      return {
        ...state,
        searchedUsersByMarried: action.payload.searchedUsersByMarried
      };
    case "searchedUsersByBodyShape":
      return {
        ...state,
        searchedUsersByBodyShape: action.payload.searchedUsersByBodyShape
      };
    case "listScrollPosition":
      return {
        ...state,
        listScrollPosition: action.payload.listScrollPosition
      };
    case "searchedUsersListScrollPositionKey":
      return {
        ...state,
        searchedUsersListScrollPositionKey:
          action.payload.searchedUsersListScrollPositionKey
      };
    case "initializeSearchParams":
      return {
        ...state,
        initializeSearchParams: action.payload.initializeSearchParams
      };
    case "prevRoute":
      return {
        ...state,
        prevRoute: action.payload.prevRoute
      };
    case "setFirebaseUser":
      return {
        ...state,
        firebaseUser: action.payload.firebaseUser,
        authResolved: action.payload.authResolved
      };
    case "setMember":
      return {
        ...state,
        member: action.payload.member
      };
    case "setUnreadCount":
      return {
        ...state,
        unreadCount: action.payload.unreadCount
      };
    case "setFcmToken": {
      return {
        ...state,
        fcmToken: action.payload.fcmToken
      };
    }
    default:
      return state;
  }
};
